import React, { useRef } from 'react';
// import { BrowserRouter, Routes, Route, Link, useNavigate } from 'react-router-dom';
import styled from './Home.module.css';
import { motion, useInView } from 'framer-motion';

const Home = () => {
    // const navigate = useNavigate();
    const textSize = 'xl:text-[30px] md:text-[25px] ph:text-[20px]';
    const classBoxForMember = 'xl:w-[243.59px] xl:h-[326.38px] md:w-[200px] md:h-[280px] ph:w-[150px] ph:h-[220px]';
    const listMenu = [
        { id: 1, img: ['/images/icon_phone1.svg'], title: '', content: 'คำแนะนำประจำวัน และประจำปี ตามประเพณีไทยที่ออกแบบมาเฉพาะคุณ' },
        { id: 1, img: ['/images/icon_phone1.svg'], title: '', content: 'สีที่แนะนำเพื่อเสริมสิริมงคลตามประเพณีไทย' },
        { id: 1, img: ['/images/icon_phone1.svg'], title: '', content: 'สีเสื้อแนะนำประจำวันตามธรรมเนียมไทย' },
        // { id: 2, img: ['/images/icon_phone2.svg','/images/icon_phone3.svg'], title: 'ฤกษ์', content: 'สามารเลือกดูถฤกษ์มงคลได้หลากหลายไม่ว่าจะเป็นวันดีที่เหมาะสำหรับการทำบุญบ้าน ทำธุรกิจ \n คุยงาน  ปิดการขายพิเศษสำหรับสมาชิก' },
        // { id: 3, img: ['/images/icon_phone4.svg','/images/icon_phone5.svg'], title: 'ดวงความรัก', content: 'ตรวจสอบความสมพงษ์คู่ของคุณ กับฤกษ์ออกเดทสุดพิเศษ' },
        // { id: 4, img: ['/images/icon_phone6.svg','/images/icon_phone7.svg','/images/icon_phone8.svg'], title: 'โปรไฟล์', content: 'จัดการข้อมูลส่วนบุคคล ข้อมูลสมาชิก บทสวดมนต์ประจำตัว สีมงคลประจำตัว' }
    ];
    // const listForMember = [
    //     { id: 1, img: '/images/icon_Exclusively_for_members1.svg', title: 'สีเสื้อมงคลวันนี้', classImg: 'xl:w-[164px] md:w-[100px] ph:w-[50px] xl:h-[139px] md:h-[90px] ph:h-[50px]' },
    //     { id: 2, img: '/images/icon_Exclusively_for_members2.svg', title: 'สีกระเป๋าสตางค์', classImg: 'xl:w-[136px] md:w-[90px] ph:w-[40px] xl:h-[139px] md:h-[80px] ph:h-[40px]' },
    //     { id: 3, img: '/images/icon_Exclusively_for_members3.svg', title: 'สีเล็บมงคล', classImg: 'xl:w-[164px] md:w-[100px] ph:w-[50px] xl:h-[139px] md:h-[90px] ph:h-[50px]' },
    //     { id: 4, img: '/images/icon_Exclusively_for_members4.svg', title: 'สีรถมงคล', classImg: 'xl:w-[192px] md:w-[140px] ph:w-[100px] xl:h-[91px] md:h-[70px] ph:h-[40px] xl:mt-16 md:mt-10 ph:mt-5' },
    //     { id: 5, img: '/images/icon_Exclusively_for_members5.svg', title: 'เลขมงคล', classImg: 'xl:w-[127px] md:w-[140px] ph:w-[100px] xl:h-[128px] md:h-[70px] ph:h-[40px]' },
    //     { id: 6, img: '/images/icon_Exclusively_for_members6.svg', title: 'ทิศมงคล', classImg: 'xl:w-[125.52px] md:w-[100px] ph:w-[50px] xl:h-[125.52px] md:h-[90px] ph:h-[50px]' },
    //     { id: 7, img: '/images/icon_Exclusively_for_members7.svg', title: 'ฤกษ์มงคล', classImg: 'xl:w-[125.52px] md:w-[100px] ph:w-[50px] xl:h-[125.52px] md:h-[80px] ph:h-[50px]' },
    //     { id: 8, img: '/images/icon_Exclusively_for_members8.svg', title: 'สีมงคลประจำตัว', classImg: 'xl:w-[138px] md:w-[100px] ph:w-[50px] xl:h-[145.95px] md:h-[100px] ph:h-[50px]' }
    // ];
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true }); 
    const ref2 = useRef(null);
    const isInView2 = useInView(ref2, { once: true }); 

    return (
        <div className='p-4'>
            {/* <section className='flex justify-between items-center text-line'>
                <p className={`${textSize} xl:pl-[200px] md:pl-[100px] ph:pl-5`}> แอปพลิเคชันดูดวงรายวันสำหรับเปิดดูในทุกๆเช้า และทุกๆวัน</p>
                <img src="/images/icon_sun.svg" alt="icon" className='xl:w-[518px] md:w-[370px] sm:w-[210px] ph:w-[150px]' />
            </section> */}
             {/* <motion.section 
                className='flex justify-between items-center text-line'
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
            >
                <motion.p 
                    className='3xl:pl-[150px] ph:pl-5 text-lg'
                    initial={{ opacity: 0, x: -50 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1, ease: "easeOut" }}
                >
                    <p className={`${textSize} 3xl:pl-[150px] xl:pl-[100px]  ph:pl-5`}> แอปพลิเคชันดูดวงรายวันสำหรับเปิดดูในทุกๆเช้า และทุกๆวัน</p>
                </motion.p>

                <motion.img 
                    src="/images/icon_sun.svg" 
                    alt="icon" 
                    className='xl:w-[518px] md:w-[370px] sm:w-[210px] ph:w-[150px]'
                    initial={{ opacity: 0, rotate: -20, scale: 0.8 }}
                    animate={{ opacity: 1, rotate: 0, scale: 1 }}
                    transition={{ duration: 1.2, ease: "easeOut" }}
                    whileHover={{ rotate: 10, scale: 1.1, transition: { duration: 0.5 } }}
                />
            </motion.section> */}
            {/* <section className='sm:flex ph:block sm:justify-between ph:justify-start items-center text-line'>
                <img src="/images/icon_moon.svg" alt="icon" className='xl:w-[518px] md:w-[370px] sm:w-[210px] ph:w-[150px]' />
                <p className={`${textSize} px-10`}> เหมาะสำหรับผู้ที่สนใจการดูดวง และเชื่อในคำแนะนำจากโหราศาสตร์
                    รวมไปถึงผู้ใช้ที่มองหาการปรับสมดุลชีวิตหรือแรงบันดาลใจในแต่ละวัน</p>
            </section> */}
            {/* <motion.section 
                className='sm:flex ph:block sm:justify-between ph:justify-start items-center text-line'
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, ease: "easeOut" }}
            >
     
                <motion.img 
                    src="/images/icon_moon.svg" 
                    alt="icon" 
                    className='xl:w-[518px] md:w-[370px] sm:w-[210px] ph:w-[150px]'
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={{ 
                        opacity: 1, 
                        scale: 1, 
                        y: [0, -10, 0]  // << รวม animate ไว้ที่เดียว
                    }}
                    transition={{ 
                        duration: 1.2, 
                        ease: "easeOut", 
                        y: { duration: 3, repeat: Infinity, ease: "easeInOut" } // << กำหนด animation loop ที่นี่
                    }}
                    whileHover={{ filter: "drop-shadow(0px 0px 10px rgba(255,255,200,0.6))" }}
                />

       
                <motion.p 
                    className='px-10 text-lg'
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 1, ease: "easeOut" }}
                >
                    <p className={`${textSize} px-10`}> เหมาะสำหรับผู้ที่สนใจการดูดวง และเชื่อในคำแนะนำจากโหราศาสตร์
                    รวมไปถึงผู้ใช้ที่มองหาการปรับสมดุลชีวิตหรือแรงบันดาลใจในแต่ละวัน</p>
                </motion.p>
            </motion.section> */}
            <p className='my-10'></p>
            {/* <section>
                <p className={`${textSize} text-center font-medium mb-5`}>ดาวน์โหลดได้แล้ววันนี้</p>
                <aside className='flex justify-center gap-5'>
                    <img src="/images/icon_google_play.svg" alt="icon" className='xl:w-[275px] md:w-[180px] ph:w-[100px]' />
                    <img src="/images/icon_app_store.svg" alt="icon" className='xl:w-[275px] md:w-[180px] ph:w-[100px]' />
                </aside>
            </section> */}
            {/* <section className='relative xl:h-[300px] md:h-[180px] ph:h-[100px] my-5 flex justify-center items-center'>
                <p className={`${textSize} text-center font-medium`}>เมนู</p>
                <img src="/images/icon_clouds_left.svg" alt="icon" className='xl:w-[275px] md:w-[180px] ph:w-[100px] absolute left-0' />
                <img src="/images/icon_clouds_right.svg" alt="icon" className='xl:w-[275px] md:w-[180px] ph:w-[100px] absolute right-0' />
            </section> */}
            <p className='h-[100px] w-full'></p>
            <motion.section 
                ref={ref}
                className='relative xl:h-[300px] md:h-[180px] ph:h-[100px] my-5 flex justify-center items-center'
                initial={{ opacity: 0 }}
                animate={isInView ? { opacity: 1 } : {}} // เริ่ม fade in เมื่อเมฆอยู่ในมุมมอง
                transition={{ duration: 1, ease: "easeOut" }}
            >
                {/* ข้อความ "เมนู" ค่อยๆ ปรากฏและขยายขึ้น */}
                <motion.p 
                    className='text-xl text-center font-medium'
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={isInView ? { opacity: 1, scale: 1 } : {}}
                    transition={{ duration: 1, ease: "easeOut" }}
                >
                    {/* <p className={`${textSize} text-center font-bold`}>เมนู</p> */}
                    <img src="/images/pichead.svg" alt="icon" className='xl:w-[879px] md:w-[800px] ph:w-[500px]' />
                </motion.p>

                {/* เมฆฝั่งซ้าย */}
                <motion.img 
                    src="/images/icon_clouds_left.svg" 
                    alt="icon" 
                    className='xl:w-[275px] md:w-[180px] ph:w-[100px] absolute left-0'
                    initial={{ y: -50, opacity: 0 }}
                    animate={isInView ? { y: [0, -5, 0], opacity: 1 } : {}}
                    transition={{ 
                        duration: 1.2, 
                        ease: "easeOut",
                        y: { duration: 3, repeat: Infinity, ease: "easeInOut" }
                    }}
                    whileHover={{ scale: 1.05 }}
                />

                {/* เมฆฝั่งขวา */}
                <motion.img 
                    src="/images/icon_clouds_right.svg" 
                    alt="icon" 
                    className='xl:w-[275px] md:w-[180px] ph:w-[100px] absolute right-0'
                    initial={{ y: -50, opacity: 0 }}
                    animate={isInView ? { y: [0, -5, 0], opacity: 1 } : {}}
                    transition={{ 
                        duration: 1.2, 
                        ease: "easeOut",
                        y: { duration: 3, repeat: Infinity, ease: "easeInOut" }
                    }}
                    whileHover={{ scale: 1.05 }}
                />
            </motion.section>
            <p className='h-[200px] w-full'></p>
            <section>
                {listMenu.map((item) => (
                    <div key={item.id}>
                        {/* <img src={item.img} alt={item.title} className="xl:w-[275px] md:w-[180px] ph:w-[100px] mx-auto mb-10" /> */}
                        <aside className='flex justify-center xl:gap-[65px] md:gap-[40px] ph:gap-[20px] mb-10'>
                            {item.img.map((image, index) => (
                                <img 
                                    key={index} 
                                    src={image} 
                                    alt={`${item.title} - ${index + 1}`} 
                                    className={`xl:w-[275px] md:w-[180px] ph:w-[100px]`}
                                />
                            ))}
                        </aside>
                        <div>
                            <p  className={`${textSize} text-center font-medium mb-10`}>{item.title}</p>
                            <p  className={`${textSize} ${styled.fontText} text-center font-sans mb-10`} dangerouslySetInnerHTML={{ __html: item.content.replace(/\n/g, '<br />') }}></p>
                        </div>
                    </div>
                ))}
            </section>
            {/* <section className='relative xl:h-[300px] md:h-[180px] ph:h-[100px] my-5 flex justify-center items-center'>
                <p className={`${textSize} text-center font-medium`}>พิเศษเฉพาะสมาชิก</p>
                <img src="/images/icon_clouds_left.svg" alt="icon" className='xl:w-[275px] md:w-[180px] ph:w-[100px] absolute left-0' />
                <img src="/images/icon_clouds_right.svg" alt="icon" className='xl:w-[275px] md:w-[180px] ph:w-[100px] absolute right-0' />
            </section> */}
             <motion.section 
                ref={ref2}
                className='relative h-[100px] flex justify-center items-center'
                initial={{ opacity: 0 }}
                animate={isInView2 ? { opacity: 1 } : {}} // เริ่ม fade in เมื่อเมฆอยู่ในมุมมอง
                transition={{ duration: 1, ease: "easeOut" }}
            >
                {/* ข้อความ "เมนู" ค่อยๆ ปรากฏและขยายขึ้น */}
                {/* <motion.p 
                    className='text-xl text-center font-medium'
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={isInView2 ? { opacity: 1, scale: 1 } : {}}
                    transition={{ duration: 1, ease: "easeOut" }}
                >
                    <p className={`${textSize} text-center font-bold`}>พิเศษเฉพาะสมาชิก</p>
                </motion.p> */}

                {/* เมฆฝั่งซ้าย */}
                {/* <motion.img 
                    src="/images/icon_clouds_left.svg" 
                    alt="icon" 
                    className='xl:w-[275px] md:w-[180px] ph:w-[100px] absolute left-0'
                    initial={{ y: -50, opacity: 0 }}
                    animate={isInView2 ? { y: [0, -5, 0], opacity: 1 } : {}}
                    transition={{ 
                        duration: 1.2, 
                        ease: "easeOut",
                        y: { duration: 3, repeat: Infinity, ease: "easeInOut" }
                    }}
                    whileHover={{ scale: 1.05 }}
                /> */}

                {/* เมฆฝั่งขวา */}
                {/* <motion.img 
                    src="/images/icon_clouds_right.svg" 
                    alt="icon" 
                    className='xl:w-[275px] md:w-[180px] ph:w-[100px] absolute right-0'
                    initial={{ y: -50, opacity: 0 }}
                    animate={isInView2 ? { y: [0, -5, 0], opacity: 1 } : {}}
                    transition={{ 
                        duration: 1.2, 
                        ease: "easeOut",
                        y: { duration: 3, repeat: Infinity, ease: "easeInOut" }
                    }}
                    whileHover={{ scale: 1.05 }}
                /> */}
            </motion.section>
            {/* <section className='grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 2xl:px-[250px] xl:px-[140px] md:px-[100px] ph:px-5'>
                {listForMember.map((item) => (
                    <div key={item.id} className={`${classBoxForMember} border-solid border-2 border-reded p-4 rounded-t-[200px] mx-auto`}>
                        <p className='pb-10'></p>
                        <p  className={`${textSize} ${styled.textLinear} text-center font-medium mb-10`}>{item.title}</p>
                        <img src={item.img} alt={item.title} className={`${item.classImg} mx-auto`} />
                    </div>
                ))}
            </section> */}
        </div>
    );
};

export default Home;
